import { Service } from "../Service";
import { IWebClient } from "./IWebClient";
import { NAMESPACE } from "./_Namespace";

export class WebClientService extends Service<IWebClient>
{
    public static override classNamespace = NAMESPACE + "WebClientService";
    public static override className = "WebClientService";
}